import {Modal, SimpleGrid, Stack, Text} from '@mantine/core';
import React from 'react';

import {PlateFieldValue} from 'notebook/integrations/plate-maps/scratch-plates/ScratchPlateDesignSummaryUtil';
import FieldLabel from 'ui-library/inputs/FieldLabel';

export interface PlateMetadataFieldsModalProps {
  opened: boolean;
  onClose: () => void;
  fields: ReadonlyArray<PlateFieldValue>;
}

/** Read-only modal listing a scratch plate's plate-level ("whole plate") metadata fields. */
export default function PlateMetadataFieldsModal({
  opened,
  onClose,
  fields,
}: PlateMetadataFieldsModalProps): JSX.Element {
  const sortedFields = [...fields].sort((a, b) => a.name.localeCompare(b.name));

  return (
    <Modal opened={opened} onClose={onClose} title="Plate metadata" size="md">
      {sortedFields.length === 0 ? (
        <Text c="dimmed">No plate metadata fields.</Text>
      ) : (
        <SimpleGrid cols={2}>
          {sortedFields.map((field) => (
            <Stack key={field.id} spacing={2}>
              <FieldLabel label={field.name} />
              {field.value != null ? <Text>{String(field.value)}</Text> : <Text c="dimmed">—</Text>}
            </Stack>
          ))}
        </SimpleGrid>
      )}
    </Modal>
  );
}
